export default __webpack_public_path__ + "static/media/section-01-bg.70b6f09e.svg";